import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";

export default class OptionCheckBoxGroup extends React.Component {
    render() {
        let {
            title,
            className,
            showClearAll,
            children,
            clearAllButtonOnClick
        } = this.props;

        return (
            <div className={`options-group ${className}`}>
                <h6 className="header">{title}</h6>
                {showClearAll && (
                    <Button
                        label="Clear All"
                        className="btn btn-lx-sm btn-outline-lx clear-all"
                        onClick={clearAllButtonOnClick}
                    />
                )}
                {children}
            </div>
        );
    }
}
OptionCheckBoxGroup.defaultProps = {
    className: "",
    showClearAll: false,
    clearAllButtonOnClick: () => {}
};

OptionCheckBoxGroup.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    showClearAll: PropTypes.bool,
    clearAllButtonOnClick: PropTypes.func,
    children: PropTypes.any
};
